export default "/_next/static/images/5c/cooperation@2x-5c348baad3a2a7b1e8849304b65d5fb4.jpg";